export const ACCOUNT_TYPE_VALUES = ['personal', 'organization'] as const;
export type AccountTypeToggleGroupValue = (typeof ACCOUNT_TYPE_VALUES)[number];

export type AccountTypeToggleGroupPropsMicrocopy = {
  ariaLabel: string;
  personal: string;
  organization: string;
};

export type AccountTypeToggleGroupPropsData = {
  userName: string;
  userProfilePicture?: string | null;
  publisherName: string;
  value: AccountTypeToggleGroupValue;
};

export type AccountTypeToggleGroupPropsDataWithMicrocopy =
  AccountTypeToggleGroupPropsData & {
    microcopy: AccountTypeToggleGroupPropsMicrocopy;
  };

export type AccountTypeToggleGroupPropsActions = {
  onValueChange: (value: AccountTypeToggleGroupValue) => void;
};

export type AccountTypeToggleGroupProps =
  AccountTypeToggleGroupPropsDataWithMicrocopy &
    AccountTypeToggleGroupPropsActions & {
      className?: string;
    };
